var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:[_vm.size, { empty: !_vm.src }],style:(_vm.bg)},[_c('Online',{attrs:{"size":_vm.size,"online":_vm.online}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }